import { AppBrands } from './constants';

export interface BrandConfig {
    name: string;
    theme: {
        headingFontFamily: string;
        fontFamily: string;
        brandColor: string;
    };
    logo: {
        type: 'svg' | 'image';
        svgComponent?: string;
        imagePath?: string;
        width?: number;
        colors?: {
            primary: string;
            accent: string;
        };
    };
    features: {
        [key: string]: boolean;
    };
}

export const brandConfigs: Record<AppBrands, BrandConfig> = {
    [AppBrands.QWIC]: {
        name: 'qwic',
        theme: {
            headingFontFamily: 'Apercu',
            fontFamily: 'Apercu',
            brandColor: '#EE7728',
        },
        logo: {
            type: 'svg',
            svgComponent: 'QwicLogo',
            width: 90,
            colors: {
                primary: '#1c1c1c',
                accent: '#ff8a00',
            },
        },
        features: {
            consumerMode: true,
            downloadInvoice: true,
            returnFromInvoice: true,
        },
    },
    [AppBrands.BREKR]: {
        name: 'brekr',
        theme: {
            headingFontFamily: 'Exo',
            fontFamily: 'OpenSans',
            brandColor: '#28a359',
        },
        logo: {
            type: 'svg',
            svgComponent: 'BrekrLogo',
            width: 90,
            colors: {
                primary: '#1c1c1c',
                accent: '#1c1c1c',
            },
        },
        features: {
            consumerMode: true,
            downloadInvoice: false,
            returnFromInvoice: false,
        },
    },
};

export const getBrandConfig = (brand: string): BrandConfig => {
    const brandKey = brand as AppBrands;
    return brandConfigs[brandKey] || brandConfigs[AppBrands.QWIC];
};
